import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import * as moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil, map } from 'rxjs/operators';
import { AuthService } from '../../../modules/shared/services/http/auth.service';
import { DEPLOY_URL } from "../../../../deploy-url";
import { Person } from "ngx-uaa/lib/models/person";
import { Router } from "@angular/router";
import { HttpAuthService } from "ngx-uaa";
import { BASE_HREF } from "../../../../base-href";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  @Input() hideMenu;

  @Input() showUserNav;

  @Input() userMenu = [];

  currentUSerSub: Subscription;

  public deployUrl: string;
  public baseHref: string = '';

  private destroy$: Subject<void> = new Subject<void>();

  userPictureOnly: boolean = true;

  user: Person;

  currentTheme = 'default';
  isDark = localStorage.getItem('darkMode') === 'true';
  currentLang = 'it';
  langMenuOpen = false;
  userMenuOpen = false;
  notLoggedMenuOpen = false;

  langMenu = [
    { title: '🇮🇹 Italiano' },
    { title: '🇬🇧 English' },
  ];

  //menu
  prenoMenu = [];
  notLoggedMenu = [];
  smallDevsMenu = [];
  userMenuAdmin;
  //menu

  // default value
  logoUrl: string;

  get userInitials(): string {
    if (!this.user) { return ''; }
    return ((this.user.firstName || '').charAt(0) + (this.user.lastName || '').charAt(0)).toUpperCase();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.langMenuOpen = false;
      this.userMenuOpen = false;
      this.notLoggedMenuOpen = false;
      this.changeDetectorRef.detectChanges();
    }
  }

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private breakpointService: NbMediaBreakpointsService,
    private authService: AuthService,
    private httpAuthService: HttpAuthService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private nbMenuService: NbMenuService,
    @Inject(DEPLOY_URL) deployUrl: string,
    @Inject(BASE_HREF) baseHref: string,
    private translateService: TranslateService,
    private elementRef: ElementRef,
  ) {
    this.deployUrl = deployUrl;
    this.baseHref = baseHref;
    this.currentLang = this.translateService.currentLang || 'it';

    this.logoUrl = this.deployUrl + "assets/images/START-BOOKING-BLU.svg";
    document.documentElement.style.setProperty("--logo-url", "url('" + this.logoUrl + "')");

    this.notLoggedMenu = [
      { title: 'header.login', link: '/auth/login' },
    ];
    this.smallDevsMenu = [
      { title: 'header.book', link: '/public' },
      { title: 'header.myBookings', link: '/public/list' },
    ];
    this.userMenuAdmin = { title: 'header.backoffice', link: '/reservation/list' };
    this.prenoMenu = [
      { title: 'header.myBookings', link: '/public/list' },
    ];
  }

  ngOnInit() {
    this.nbMenuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'lang-menu'),
        map(({ item }) => item.title),
        takeUntil(this.destroy$)
      )
      .subscribe(title => {
        this.switchLang(title.includes('Italiano') ? 'it' : 'en');
      });

    this.themeService.onThemeChange().subscribe((theme)=>{
     this.currentTheme = theme.name;
     this.isDark = theme.name.endsWith('-dark');
     const navbarLogoPath = this.deployUrl + 'assets/images/' + theme.name + '-theme/logo_navbar.svg';
     this.logoUrl = navbarLogoPath;
     document.documentElement.style.setProperty("--logo-url", "url('" + this.logoUrl + "')");
    })
    this.currentUSerSub = this.authService.getCurrentUserBS().subscribe(next => {
      if (!next) {
        // sessionStorage.removeItem('stepper-form');
        // sessionStorage.removeItem('selectedIndex');
        // sessionStorage.removeItem('steps');
      }

      this.user = next;
      let hasAdminLink = false;
      this.smallDevsMenu.forEach(value => {
        if (value.title === 'header.backoffice') {
          hasAdminLink = true;
        }
      });
      if (this.authService.hasBackofficeRole() && !hasAdminLink) {
        this.smallDevsMenu.splice(1, 0, this.userMenuAdmin);
      }

      this.changeDetectorRef.detectChanges();
    });

    this.smallDevsMenu = ([...this.prenoMenu, ...this.userMenu]);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.changeDetectorRef.detach();
    this.currentUSerSub.unsubscribe();
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  switchLang(lang: string): void {
    this.currentLang = lang;
    localStorage.setItem('lang', lang);
    moment.locale(lang);
    this.translateService.use(lang);
  }

  toggleDarkMode(): void {
    this.isDark = !this.isDark;
    localStorage.setItem('darkMode', String(this.isDark));
    const baseTheme = this.currentTheme.replace(/-dark$/, '');
    this.themeService.changeTheme(this.isDark ? baseTheme + '-dark' : baseTheme);
    this.applyDarkModeVars();
  }

  onLangSelect(title: string): void {
    if (title.includes('English')) {
      this.switchLang('en');
    } else {
      this.switchLang('it');
    }
  }

  onDropdownFocusOut(event: FocusEvent, menu: string): void {
    const dropdown = (event.currentTarget as HTMLElement);
    setTimeout(() => {
      if (!dropdown.contains(document.activeElement)) {
        this.closeDropdown(menu);
        this.changeDetectorRef.detectChanges();
      }
    }, 0);
  }

  toggleDropdown(menu: string): void {
    if (menu === 'lang') { this.langMenuOpen = !this.langMenuOpen; }
    if (menu === 'user') { this.userMenuOpen = !this.userMenuOpen; }
    if (menu === 'notLogged') { this.notLoggedMenuOpen = !this.notLoggedMenuOpen; }

    setTimeout(() => {
      const item = document.querySelector('.a11y-dropdown__item') as HTMLElement;
      if (item) { item.focus(); }
    }, 0);
  }

  private closeDropdown(menu: string): void {
    if (menu === 'lang') { this.langMenuOpen = false; }
    if (menu === 'user') { this.userMenuOpen = false; }
    if (menu === 'notLogged') { this.notLoggedMenuOpen = false; }
  }

  private applyDarkModeVars(): void {
    const root = document.documentElement;
    if (this.isDark) {
      root.style.setProperty('--card-bg', '#1a1a2e');
      root.style.setProperty('--card-text', '#e0e0e0');
      root.style.setProperty('--input-bg', '#16213e');
      root.style.setProperty('--card-link', '#e57388');
      root.style.setProperty('--confirm-bar-border', '#2a3a5c');
      root.style.setProperty('--profile-avatar-bg', '#3b1a2e');
    } else {
      root.style.removeProperty('--card-bg');
      root.style.removeProperty('--card-text');
      root.style.removeProperty('--input-bg');
      root.style.removeProperty('--card-link');
      root.style.removeProperty('--confirm-bar-border');
      root.style.removeProperty('--profile-avatar-bg');
    }
  }

}
